<template>
	<div class="hero">

		<!-- LEFT: заголовок -->
		<div class="hero__left">
			<p class="hero__label">K&M REMODELING SERVICES &nbsp;/&nbsp; CHARLOTTE, NC</p>
			<h1>Custom Kitchen & Home Remodeling in Charlotte and Surrounding Areas</h1>
			<p class="hero__sub">Family-owned. Fully Licensed & insured. Full-home, kitchen and bathroom remodeling for Charlotte's finest neighborhoods.</p>

			<ul class="hero__highlights">
				<li class="hero__highlight">
					<span class="hero__highlight-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
							<path d="M6 3h12l4 6-10 12L2 9Z" />
							<path d="M2 9h20" />
							<path d="M11 3 8 9l4 12 4-12-3-6" />
						</svg>
					</span>
					<span class="hero__highlight-text">Only the Best Quality Materials</span>
				</li>
				<li class="hero__highlight">
					<span class="hero__highlight-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="8" cy="8" r="3.1" />
							<path d="M2.5 19.2c.6-3.5 2.9-5.7 5.5-5.7s4.9 2.2 5.5 5.7" />
							<circle cx="16.6" cy="9.1" r="2.3" />
							<path d="M14.9 13.7c2 .3 3.6 2.1 4.1 4.5" />
						</svg>
					</span>
					<span class="hero__highlight-text">Local & Family Owned</span>
				</li>
				<li class="hero__highlight">
					<span class="hero__highlight-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
							<path d="M6.5 3h7.3L18 6.8V20a1 1 0 0 1-1 1H6.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
							<path d="M13.8 3v3.8h3.9" />
							<path d="M8.3 13.6l2.1 2.1 4.3-4.5" />
						</svg>
					</span>
					<span class="hero__highlight-text">Guaranteed fixed price</span>
				</li>
				<li class="hero__highlight">
					<span class="hero__highlight-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
							<path d="M12 3.2 19 6v5.1c0 5-3 8.6-7 10.1-4-1.5-7-5.1-7-10.1V6l7-2.8Z" />
							<path d="M8.6 12.1l2.3 2.3 4.5-4.7" />
						</svg>
					</span>
					<span class="hero__highlight-text">No surprises, on schedule</span>
				</li>
			</ul>

			<button class="hero__cta" @click="showPopup = true">Schedule Your Complimentary Consultation</button>

			<div class="hero__reviews">
				<GoogleReviews widget-id="ae89af49-2e95-4bdb-800b-b0fa3a3845d1" />
			</div>
		</div>

		<!-- RIGHT: слайдер -->
		<div class="hero__right">
			<div
				class="slider"
				@mouseenter="pauseAutoplay"
				@mouseleave="startAutoplay"
				@touchstart.passive="onTouchStart"
				@touchmove="onTouchMove"
				@touchend="onTouchEnd"
			>
				<div class="slider__track" :style="trackStyle">
					<div class="slider__slide" v-for="(src, i) in slides" :key="i">
						<img :src="src" alt="Charlotte NC remodeling services" loading="lazy">
					</div>
				</div>

				<button class="slider__btn slider__btn--prev" @click="onPrevClick" aria-label="Previous">&#8592;</button>
				<button class="slider__btn slider__btn--next" @click="onNextClick" aria-label="Next">&#8594;</button>

				<!-- dots -->
				<div class="slider__dots">
					<button
						v-for="(_, i) in slides"
						:key="i"
						class="slider__dot"
						:class="{ active: index === i }"
						@click="goTo(i)"
						:aria-label="`Slide ${i+1}`"
					></button>
				</div>
			</div>
		</div>

		<transition name="fade">
			<popap-view v-if="showPopup" @close="showPopup = false" />
		</transition>

	</div>
</template>

<script>
import PopapView from '@/components/PopapView.vue';
import GoogleReviews from '@/components/GoogleReviews.vue';

export default {
	name: 'ScrolSet',

	components: { PopapView, GoogleReviews },

	props: {
		slides: {
			type: Array,
			default: () => [
				'/flip/monro/monro_05.jpg',
				'/flip/monro/monro_010.jpg',
				'/images/kitchen/kitchen-remodel-charlotte-124.jpg',
				'/flip/kilcullen/after-living-03.jpg',
				'/images/kitchen/kitchen-remodel-charlotte-013.jpg',
				'/images/kitchen/kitchen-remodel-charlotte-024.webp',
				'/flip/kilcullen/after-kitchen-01.jpg',
				'/flip/kilcullen/after-bath-02.jpg',
				'/flip/kilcullen/after-exterior-02.jpg',
				//'/slider/remodeling-services-charlotte-01.webp',
				// '/slider/remodeling-services-charlotte-02.webp',
				'/slider/remodeling-services-charlotte-03.webp',
				// '/slider/remodeling-services-charlotte-04.webp',
				//'/slider/remodeling-services-charlotte-05.webp',
				// '/slider/remodeling-services-charlotte-07.webp',
			]
		},
		autoplayInterval: { type: Number, default: 3500 },
	},

	data() {
		return {
			index: 0,
			timer: null,
			touchStartX: 0,
			touchStartY: 0,
			touchDeltaX: 0,
			showPopup: false,
		};
	},

	computed: {
		trackStyle() {
			return {
				transform: `translateX(-${this.index * 100}%)`,
			};
		},
	},

	methods: {
		next() {
			this.index = this.index < this.slides.length - 1 ? this.index + 1 : 0;
		},
		prev() {
			this.index = this.index > 0 ? this.index - 1 : this.slides.length - 1;
		},
		goTo(i) {
			this.index = i;
			this.restartAutoplay();
		},
		onNextClick() {
			this.next();
			this.restartAutoplay();
		},
		onPrevClick() {
			this.prev();
			this.restartAutoplay();
		},
		startAutoplay() {
			if (this.timer) return;
			this.timer = setInterval(this.next, this.autoplayInterval);
		},
		pauseAutoplay() {
			clearInterval(this.timer);
			this.timer = null;
		},
		restartAutoplay() {
			this.pauseAutoplay();
			this.startAutoplay();
		},
		onTouchStart(e) {
			this.pauseAutoplay();
			this.touchStartX = e.touches[0].clientX;
			this.touchStartY = e.touches[0].clientY;
			this.touchDeltaX = 0;
		},
		onTouchMove(e) {
			const touch = e.touches[0];
			const deltaX = touch.clientX - this.touchStartX;
			const deltaY = touch.clientY - this.touchStartY;
			this.touchDeltaX = deltaX;

			// свайп горизонтальнее вертикального скролла — перехватываем жест
			if (Math.abs(deltaX) > Math.abs(deltaY)) {
				e.preventDefault();
			}
		},
		onTouchEnd() {
			if (this.touchDeltaX > 40)       this.prev();
			else if (this.touchDeltaX < -40) this.next();
			this.touchStartX = 0;
			this.touchDeltaX = 0;
			this.startAutoplay();
		},
	},

	mounted()       { this.startAutoplay(); },
	beforeUnmount() { this.pauseAutoplay(); },
};
</script>

<style lang="scss" scoped>
// ─── HERO LAYOUT ─────────────────────────────────────────
.hero {
	display: flex;
	align-items: center;
	gap: 40px;
	padding: 35px 30px 50px;
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 900px) {
		flex-direction: column;
		padding: 20px 15px;
		gap: 20px;
	}
}

// ─── LEFT ────────────────────────────────────────────────
.hero__left {
	flex: 0 0 420px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	@media (max-width: 1100px) { flex: 0 0 300px; }
	@media (max-width: 900px)  { flex: none; width: 100%; }
}

.hero__label {
	font-size: 11px;
	letter-spacing: 0.09em;
	text-transform: uppercase;
	color: rgba(25, 25, 25, 0.4);
	font-weight: 500;
	margin: 0;
}

h1 {
	font-size: 34px;
	font-weight: 500;
	color: rgb(25, 25, 25);
	line-height: 1.15;
	margin: 0;
	opacity: 0;
	transform: translateY(16px);
	animation: fadeUp 0.65s cubic-bezier(.22, .9, .36, 1) 0.15s forwards;

	@media (max-width: 1100px) { font-size: 30px; }
	@media (max-width: 900px)  { font-size: 28px; }
	@media (max-width: 425px) { font-size: 22px; }
}

.hero__sub {
	font-size: 14px;
	line-height: 1.6;
	color: rgba(25, 25, 25, 0.8);
	max-width: 300px;
	margin: 0;

	@media (max-width: 900px) { max-width: 100%; }
}

// ─── HIGHLIGHTS LIST ─────────────────────────────────────
.hero__highlights {
	list-style: none;
	margin: 4px 0 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.hero__highlight {
	display: flex;
	align-items: center;
	gap: 10px;
}

.hero__highlight-icon {
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: rgba(216, 158, 28, 0.12);
	color: #d89e1c;

	svg {
		width: 16px;
		height: 16px;
	}
}

.hero__highlight-text {
	font-size: 1.0625rem;
	font-weight: 500;
	line-height: 1.3;
	color: rgb(25, 25, 25);
}

// ─── CTA BUTTON ──────────────────────────────────────────
.hero__cta {
	width: 100%;
	padding: 15px clamp(18px, 5vw, 32px);
	background-color: #d89e1c;
	color: #fff;
	font-size: clamp(13px, 1.4vw, 15px);
	font-weight: 500;
	line-height: 1.3;
	text-align: center;
	border-radius: 100px;
	border: none;
	cursor: pointer;
	transition: background-color 0.2s ease, transform 0.15s ease;

	&:hover {
		background-color: #bf8b18;
	}

	&:active {
		transform: translateY(1px);
	}

	&:focus-visible {
		outline: 3px solid rgba(216, 158, 28, 0.5);
		outline-offset: 3px;
	}

	@media (max-width: 425px) {
		font-size: 13px;
		padding: 13px 18px;
	}
}

// ─── REVIEWS WIDGET ──────────────────────────────────────
.hero__reviews {
	width: 100%;

	:deep(.reviews-wrapper) {
		margin: 0;
		padding: 0;
	}
}

// ─── POPUP TRANSITION ────────────────────────────────────
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

// ─── RIGHT ───────────────────────────────────────────────
.hero__right {
	flex: 1;
	min-width: 0;
}

// ─── SLIDER ──────────────────────────────────────────────
.slider {
	position: relative;
	border-radius: 16px;
	overflow: hidden;
	background: #f0f0f0;

	&__track {
		display: flex;
		transition: transform 500ms cubic-bezier(.22, .9, .4, 1);
	}

	&__slide {
		flex: 0 0 100%;

		img {
			width: 100%;
			height: 480px;
			object-fit: cover;
			display: block;

			@media (max-width: 900px) { height: 300px; }
			@media (max-width: 500px) { height: 220px; }
		}
	}

	// ── навигация ──
	&__btn {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		background: rgba(255, 255, 255, 0.75);
		backdrop-filter: blur(4px);
		border: none;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		font-size: 18px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #191919;
		transition: background 0.2s ease;
		z-index: 5;

		&:hover { background: rgba(255, 255, 255, 0.95); }

		&--prev { left: 14px; }
		&--next { right: 14px; }

		@media (max-width: 600px) { display: none; }
	}

	// ── dots ──
	&__dots {
		position: absolute;
		bottom: 12px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		gap: 6px;
		z-index: 5;
	}

	&__dot {
		width: 7px;
		height: 7px;
		border-radius: 50%;
		border: none;
		background: rgba(255, 255, 255, 0.5);
		cursor: pointer;
		padding: 0;
		transition: background 0.2s, transform 0.2s;

		&.active {
			background: #ffffff;
			transform: scale(1.3);
		}
	}
}

// ─── ANIMATION ───────────────────────────────────────────
@keyframes fadeUp {
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
</style>